import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { STATUS } from '@features/General'

export interface IAddUserPayload {
    contact: string
    role: string
    password: string
}

export interface IState {
    status: string
    success: boolean
    result: boolean
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    success: true,
    result: false,
    errors: null
}

const addUserCreateSlice = createSlice({
    name: 'hub/users/add-user-with-role',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IAddUserPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.result = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const addUserCreateActions = addUserCreateSlice.actions
export default addUserCreateSlice.reducer
